import { j as r } from "./kezios-design-system.esm172.js";
import { Container as l, Flex as i, Text as m } from "@mantine/core";
import { SectionLayout as d } from "./kezios-design-system.esm96.js";
import e from "./kezios-design-system.esm191.js";
import { Spacing as n } from "./kezios-design-system.esm135.js";
const u = ({
  title: s,
  description: o,
  cta: t,
  rightSection: c,
  ...a
}) => /* @__PURE__ */ r.jsx(l, { className: e.container, size: "100%", bg: "gray.0", ...a, children: /* @__PURE__ */ r.jsx(d, { children: /* @__PURE__ */ r.jsxs(i, { direction: "column", gap: n.s12, children: [
  /* @__PURE__ */ r.jsxs(i, { gap: n.s16, align: "center", children: [
    /* @__PURE__ */ r.jsxs(
      i,
      {
        className: e.subContainer,
        direction: "column",
        gap: n.s6,
        children: [
          /* @__PURE__ */ r.jsx(m, { variant: "displayXl.semibold", component: "h1", c: "gray.9", children: s }),
          /* @__PURE__ */ r.jsx("div", { children: o })
        ]
      }
    ),
    /* @__PURE__ */ r.jsx("div", { className: `${e.rightContainer} desktop`, children: c })
  ] }),
  t
] }) }) });
export {
  u as HeroSectionRow
};
